<template>
  <div class="swiz">
    <div class="swiz__appbar">
      <button
        type="button"
        class="swiz__back"
        :title="current === 1 ? 'Salir' : 'Atrás'"
        @click="back"
        >
        <hero-icon :icon="ChevronLeftIcon" :size="20" />
      </button>
      <span class="swiz__logo">S</span>
      <span class="swiz__brand">{{ isEdit ? 'Editar inmueble' : 'Nuevo inmueble' }}</span>
    </div>

    <div class="swiz__progress">
      <stepper-header :stepper="stepper" :property="property" />
    </div>

    <div class="swiz__content">
      <v-stepper v-model="stepper" class="swiz__stepper elevation-0">
        <v-stepper-items>
          <v-stepper-content class="pa-0" step="1">
            <Type
              v-if="stepper == 1"
              @continue="createDraft"
              :fetchedProperty="property"
            />
          </v-stepper-content>

          <v-stepper-content class="pa-0" step="2">
            <characteristics
              v-if="stepper == 2"
              ref="characteristics"
              @continue="fillData"
              :fetchedProperty="property"
            />
          </v-stepper-content>

          <v-stepper-content class="pa-0" step="3">
            <Description
              v-if="stepper == 3"
              ref="description"
              @continue="fillData"
              :fetchedProperty="property"
            />
          </v-stepper-content>

          <v-stepper-content class="pa-0" step="4">
            <Pictures
              v-if="stepper == 4"
              @updateImages="updateImages"
              @continue="fillData"
              :fetchedProperty="property"
            />
          </v-stepper-content>

          <v-stepper-content class="pa-0" step="5">
            <Price
              v-if="stepper == 5"
              @continue="publish"
              :fetchedProperty="property"
            />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import StepperHeader from "@/components/properties/create/StepperHeader";
import Type from "@/components/properties/create/stepper/Type";
import Description from "@/components/properties/create/stepper/Description";
import Characteristics from "@/components/properties/create/stepper/Characteristics";
import Pictures from "@/components/properties/create/stepper/Pictures";
import Price from "@/components/properties/create/stepper/Price";
import HeroIcon from "@/components/shared/HeroIcon";
import ChevronLeftIcon from "heroicons/24/outline/chevron-left.svg";

export default {
  data() {
    return {
      stepper: 1,
      ChevronLeftIcon,
      property: {
        id: null
      }
    };
  },

  props: {
    fetchedProperty: {
      type: Object,
      required: false,
      default: () => {
        return {
          id: null
        };
      }
    }
  },

  components: {
    StepperHeader,
    Type,
    Description,
    Pictures,
    Price,
    Characteristics,
    HeroIcon
  },

  mounted() {
    this.property = this.fetchedProperty;
  },

  computed: {
    current() {
      return parseInt(this.stepper);
    },

    isEdit() {
      return !!(this.fetchedProperty && this.fetchedProperty.id);
    }
  },

  methods: {
    back() {
      if (this.current === 1) this.$router.go(-1);
      else this.stepper -= 1;
    },

    createDraft(property) {
      this.stepper = 2;
      this.property = property;
    },

    fillData(property) {
      this.stepper = parseInt(this.stepper) + 1;
      this.property = property;
    },

    updateImages(images) {
      this.property.images = images;
    },

    publish() {
      if (this.$route.query.ownerId) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: "Inmuebles", params: { success: true } });
      }
    }
  }
};
</script>

<style scoped>
.swiz { padding-bottom: 48px; }

/* appbar — back lives here */
.swiz__appbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 18px;
  background: #fff;
  border-bottom: 1px solid #ece7de;
  position: sticky;
  top: 0;
  z-index: 3;
}
.swiz__back {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: none;
  border: none;
  cursor: pointer;
  color: #1a1814;
  transition: background 0.15s ease;
}
.swiz__back:hover { background: #f1ece3; }
.swiz__logo {
  flex: none;
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: #b52118;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 15px;
}
.swiz__brand { font-size: 15px; font-weight: 700; color: #1a1814; }

.swiz__progress { padding: 24px 24px 8px; }

.swiz__content {
  max-width: 760px;
  margin: 0 auto;
  padding: 8px 24px 0;
}
.swiz__stepper { background: transparent !important; }
.swiz__stepper >>> .v-stepper__content { padding: 0 !important; }

@media (max-width: 640px) {
  .swiz__progress { padding: 18px 16px 6px; }
  .swiz__content { padding: 8px 16px 0; }
}
</style>
